package com.eladfinish.bible.contest.screens.search.model

data class LocalSearchRequest(
    val originalExpression: String,
    val regexInput: String,
    val withNikudAndTeamim: Boolean,
    val withNikud: Boolean,
    val withTeamim: Boolean,
    val onlyQri: Boolean,
    val searchMode: SearchMode,
    val searchedChapters: List<SearchPlaceData>,
    val isPremium: Boolean,
)

data class SearchDebugContext(
    var regex: String = "",
    var bookName: String = "",
    var chapterName: String = "",
    var foundVerse: String = "",
    var content: String = "",
    var offset: Int = 0,
    var groupsNum: Int = 0,
    var matchResult: MatchResult? = null,
)
